import $ from 'jquery';

let $modal = $( '.modal' );

$( () => {
   const updateModal = ( hash ) => {
    if ( hash == '' ) {
      $( 'body' ).removeClass( 'no-scroll' )
      $( '.video-modal' ).length ? $( '.video-modal' ).trigger( 'pause' ) : '';
    }

    if (  hash && hash.startsWith( '#!' )  ) {
      if (  hash !== '#!'  ) {
        $( 'body' ).addClass( 'no-scroll' );
      } else {
        $( 'body' ).removeClass( 'no-scroll' );
        $( '.video-modal' ).length ? $( '.video-modal' ).trigger( 'pause' ) : '';
      }
    }
  }

  if ( $modal.length ) {
    $( window ).on( 'hashchange', function() {
      updateModal( location.hash );
    });
    
    updateModal( location.hash );
  }
  //this is so the modal is initially hidden on page load
  setTimeout( () => {
    $( $modal ).addClass( 'visible' );
  }, 100 )

});